import { Component, OnInit, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  @Input() config: any;
  private isPlaying = false;
  constructor() { }

  ngOnInit() {
  }

  music(id: string) {
    const audio: HTMLAudioElement = <HTMLAudioElement>document.getElementById(id);
    if (!this.isPlaying) {
      audio.play();
    } else {
      audio.pause();
    }
    this.isPlaying = !this.isPlaying;
  }
}
